import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhySection from "./components/WhySection";
import CategoriesSection from "./components/CategoriesSection";
import HowItWorks from "./components/HowItWorks";
import ArticlePreview from "./components/ArticlePreview";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

const organizationJsonLd = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Kakobuy Polska",
  url: "https://kakobuypolska.fun/",
  description: "Kompletny przewodnik Kakobuy Spreadsheet dla użytkowników z Polski. Najlepsza lista produktów, poradniki i bezpieczne zakupy przez chińskich agentów.",
  foundingDate: "2024",
  areaServed: {
    "@type": "Country",
    name: "Polska",
  },
});

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: organizationJsonLd }}
      />
      <Navbar />
      <Hero />
      <WhySection />
      <CategoriesSection />
      <HowItWorks />
      <ArticlePreview />
      <ArticlesSection />
      <FAQSection />
      <Footer />
    </main>
  );
}